/**
 * Method called for every firebase child_added or child_removed event to avoid calling the server endpoint if the item
 * is already in the redux state.
 * Use cases:
 *  - child_added events fired for the first time after full sync.
 *  - User add an object and a child_added event is fired for that same item.
 *  - User updates an object and a child_modified event is fired for that same item.
 * @param objectEntriesList object list that comes from getState, for example getState().entities.calendar
 * @param id id of the item
 * @param updated timestamp of the item coming from firebase
 * @param arrayFieldName Used if the array is an object, if it is it this is the fieldName to check for the id
 * @returns {boolean|*} true if it exists and timestamp is equal, false if it doesn't exist of the timestamp is different
 */
export function upToDate(objectEntriesList, id, updated, arrayFieldName = null) {
  return (
    objectEntriesList &&
    objectEntriesList[id] &&
    (!updated || objectEntriesList[id].updated >= updated - 1)
  );
}

export function isNew(objectEntriesList, id) {
  return !objectEntriesList || !objectEntriesList[id];
}
